import { EditorStarterItem } from './items/item-type';
import { TICKS_HEIGHT } from './timeline/ticks/constants';

export const MIN_TIMELINE_ZOOM = -1;
export const MAX_TIMELINE_WIDTH = 40_000; // 더 높은 최대 zoom을 원한다면 이 값을 증가시키세요

export const PLAYHEAD_WIDTH = 12;

// playhead가 보이도록 충분한 공간을 만들고, 왼쪽 가장자리에 붙지 않도록 패딩 추가
export const TIMELINE_HORIZONTAL_PADDING = Math.ceil(PLAYHEAD_WIDTH / 2) + 1;

export const scrollbarStyle: React.CSSProperties = {
  scrollbarWidth: 'thin',
  scrollbarColor:
    'var(--color-editor-starter-scrollbar-thumb) var(--color-editor-starter-scrollbar-track)',
};

export const ITEM_COLORS: Record<EditorStarterItem['type'], string> = {
  image: 'var(--comp-trackItemBg-green)',
  gif: 'var(--comp-trackItemBg-green)',
  webp: 'var(--comp-trackItemBg-green)',
  text: 'var(--comp-trackItemBg-secondary)',
  video: 'var(--comp-trackItemBg-neutral)',
  solid: 'var(--comp-trackItemBg-red)',
  blur: 'var(--comp-trackItemBg-neutral)',
  audio: 'var(--comp-trackItemBg-yellow)',
  captions: 'var(--comp-trackItemBg-primary)',
  code: 'var(--comp-trackItemBg-secondary)',
  pdf: 'var(--comp-trackItemBg-green)',
  ppt: 'var(--comp-trackItemBg-green)',
  group: 'var(--comp-trackItemBg-neutral)',
};

export const DEFAULT_COMPOSITION_WIDTH = 1080;
export const DEFAULT_COMPOSITION_HEIGHT = 1920;
export const DEFAULT_FPS = 30;

export const SCROLL_EDGE_THRESHOLD = 200; // auto-scroll을 활성화하는 가장자리로부터의 픽셀 거리
export const MAX_AUTOSCROLL_SPEED = 10;

export const MAX_FADE_DURATION_SECONDS = Infinity;

export const CANVAS_PADDING = 16;

// Timeline snapping
// snap point 근접성을 평가할 때 사용되는 기본 픽셀 임계값
export const DEFAULT_TIMELINE_SNAPPING_THRESHOLD_PIXELS = 5;

// 타임라인에 SidePanel ticks.tsx의 margin 공간
export const TIMELINE_DIVDER_HEIGHT = 24;

// 타임라인에 SidePanel ticks.tsx의 margin 공간 + header.tsx의 height
export const TIMELINE_HEADER_HEIGHT = TICKS_HEIGHT + TIMELINE_DIVDER_HEIGHT;
